module.exports = __webpack_public_path__ + "media/hyper/fonts/Nunito-Regular-f8c1d028eab80594702332e512d858ff.ttf";